import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const STATUS_CONFIG = [
  { key: "0", label: "Pending", className: "bg-silver text-dark" },
  { key: "1", label: "Waiting", className: "bg-dark-grey text-light" },
  { key: "2", label: "Arrived", className: "bg-primary text-light" },
  {
    key: "3-4",
    label: "Scanned",
    className: "bg-info text-light",
    merge: ["3", "4"],
  },
  { key: "5", label: "En Route", className: "bg-success text-light" },
  { key: "-1", label: "Failed", className: "bg-danger text-white" },
  { key: "scheduled", label: "Scheduled", className: "bg-warning text-white" },
];

const StatusTooltipWrapper = ({ item, children }) => {
  const tooltipRef = useRef(null);
  const lockedRef = useRef(false);

  const getCount = (status) => {
    const config = STATUS_CONFIG.find((s) => s.key === status);

    if (config?.merge) {
      return (
        item?.statusGroups
          ?.filter((s) => config.merge.includes(s.status))
          ?.reduce((sum, s) => sum + s.count, 0) ?? 0
      );
    }

    return item?.statusGroups?.find((s) => s.status === status)?.count ?? 0;
  };

  const tooltipContent = `
    <div style="font-size:13px;">
      ${STATUS_CONFIG.filter(({ key }) => getCount(key) > 0)
        .map(
          ({ key, label, className }) => `
        <div class="mb-1">
          <span class="badge ${className}">${getCount(key)} ${label}</span>
        </div>`,
        )
        .join("")}
    </div>
  `;

  useEffect(() => {
    const el = document.querySelector(
      `[data-status-tooltip="${item.branchId}"]`,
    );
    if (!el || !window.bootstrap?.Tooltip) return;

    try {
      if (el._tooltip) el._tooltip.dispose();
    } catch {}

    const tooltip = new window.bootstrap.Tooltip(el, {
      html: true,
      sanitize: false,
      trigger: "manual",
    });

    tooltipRef.current = tooltip;
    el._tooltip = tooltip;

    const show = () => {
      if (!lockedRef.current) tooltip.show();
    };

    const lockAndHide = () => {
      lockedRef.current = true;
      tooltip.hide();
    };

    const unlockOnMouseLeave = () => {
      lockedRef.current = false;
      tooltip.hide();
    };

    el.addEventListener("mouseenter", show);
    el.addEventListener("mouseleave", unlockOnMouseLeave);
    el.addEventListener("click", lockAndHide, true);

    document.addEventListener(
      "mousedown",
      (e) => {
        if (e.target.closest('[data-bs-toggle="modal"]')) lockAndHide();
      },
      true,
    );

    return () => {
      el.removeEventListener("mouseenter", show);
      el.removeEventListener("mouseleave", unlockOnMouseLeave);
      el.removeEventListener("click", lockAndHide, true);
      tooltip.dispose();
    };
  }, [item]);

  return (
    <div
      className="d-flex justify-content-around gap-2 cursor-pointer"
      data-status-tooltip={item.branchId}
      data-bs-title={tooltipContent}
      data-bs-html="true"
    >
      {children}
    </div>
  );
};

StatusTooltipWrapper.propTypes = {
  item: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default StatusTooltipWrapper;
